<template>
  <section class="news-section">
    <header-inner/>
    <wrapper v-if="entry && entry.title">
      <menu-news></menu-news>
      <article-page :content="entry" :back-url="`/news/#tagId${this.$route.params.category}`" back-title="Вернуться к списку новостей">
        <span v-html="entry.text"></span>
      </article-page>
<!--      <article-related :list="related" :title="'Актуальные новости'" url="/news/"/>-->
    </wrapper>
  </section>
</template>

<script>
  import HeaderInner from '../../../components/header/HeaderInner'
  import CardNewsSmall from '../../../components/shared/cards/CardNewsSmall'
  import ArticlePage from "../../../components/articles/ArticlePage";
  import ArticleRelated from "../../../components/articles/ArticleRelated";
  import MenuNews from "../../../components/news/MenuNews";
  import ContentVideo from "../../../components/shared/content/ContentVideo";

  export default {
    async asyncData({ $axios, app, route, redirect, store, query }) {
      // let page = [];
      // try {
      //   const response = await $axios.$get(`${process.env.apiUrl}/methods/news/get_item/?id=${route.params.category}`);
      //   page = response;
      //   return {page}
      // } catch (e) {
      //   console.log(e);
      // }

      await Promise.all([
        store.dispatch('content/loadSingle', { sID: 'news', ID: route.params.category }),
        store.dispatch('content/loadEntities', { sID: 'news' }),
      ]);

      return {}
    },
    head () {
      if(this.entryTitle) {
        return {
          title: this.entryTitle,
          meta: [
            {
              hid: `description`,
              name: `description`,
              content: this.entry  ? this.entry.preview_text : '',
            },
            {
              hid: `keywords`,
              name: 'keywords',
              keywords: ''
            }
          ]
        }
      }
    },
    computed: {
      entry() {
        return this.$store.state.content.single.news;
      },
      entryTitle() {
        return this.entry ? this.entry.title : '';
      },
      newsLoaded() {
        return this.$store.state.content.entities.news.loaded;
      },
      entryDate() {
        const [d, m, y] = this.entry.date.split('.');
        return { d, m, y };
      },
      related() {
        const allNews = this.$store.state.content.entities.news.items;
        const result = [];
        if (allNews) {
          allNews.forEach(news => {
            let [d, m, y] = news.date.split('.');
            if (this.entryDate.m === m && this.entryDate.y === y && this.entry.id !== news.id) {
              result.push(news);
            }
          });
        }
        return result;
      },
    },
    mounted() {
      this.$store.dispatch('content/loadSingle', { sID: 'news', ID: this.$route.params.category });
      if(!this.newsLoaded)  this.$store.dispatch('content/loadEntities', { sID: 'news' });
    },
    watch: {
      entrySlides() {
        if (this.$refs.slider) {
          this.$refs.slider.rebuild();
        }
      },
    },
    components: {
      ArticleRelated,
      ArticlePage,
      HeaderInner,
      CardNewsSmall,
      MenuNews,
      ContentVideo
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../../assets/vars", "../../../assets/mixins";

  .article-content {
    padding: 35px 0;
  }

  .article-text {
    padding: 35px 0;
  }

  .article-video {
    padding: 35px 0;
    @media (max-width: 600px) {
      padding: 15px 0;
    }
    /deep/ video {
      background: black;
    }
  }

  .news-more {
    padding: 20px 0 90px;
  }

  .appendix {
    border-top: 4px solid $color-text;
    padding: 75px 0 150px;
    @media (max-width: 900px) {
      padding: 35px 0 75px;
    }
    @media (max-width: 600px) {
      padding: 25px 0 25px;
    }
  }

</style>



// WEBPACK FOOTER //
// pages/news/_category/index.vue